var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.577 11.444a.885.885 0 0 1 0 1.112C21.261 14.213 17.024 19 12 19s-9.26-4.787-10.577-6.444a.885.885 0 0 1 0-1.112C2.739 9.787 6.976 5 12 5s9.26 4.787 10.577 6.444Zm-5.106-2.25c1.25.948 2.278 2.013 2.968 2.806-.69.793-1.718 1.858-2.968 2.806C15.779 16.088 13.888 17 12 17s-3.78-.912-5.47-2.194C5.278 13.858 4.25 12.793 3.56 12c.69-.793 1.718-1.858 2.968-2.806C8.221 7.912 10.112 7 12 7s3.78.912 5.47 2.194Z",
  fill: "currentColor"
})));
export default SvgEyeOn;